<template>
    <div class="video video-watcher" v-if="watch">
        <div class="video-player">

            <div class="wrapper">

                <youtube :fit-parent="true" :player-vars="options" :resize="true" :video-id="videoId"
                         @playing="playing"></youtube>

            </div>

        </div>

        <div class="video-info">

            <h4 class="title" v-html="fields.title">

            </h4>
            <p class="description" v-html="fields.description">

            </p>
            <div class="file-categories">
                <ul>
                    <li class="badge"
                        v-for="(ids,category) in fileCategories">
                        {{category}}
                    </li>
                </ul>
            </div>

            <div class="actions result-actions">
                <div class="file-preview result-action" v-if="fields.url">
                    <div class="file-preview-info">
                        <a @click="watch($event)" class="action action-prevew">
                                <span
                                        class="preview-language">{{fields.lang | uppercase}}</span>
                        </a>
                    </div>
                    <div class="dropdown preview-action action-preview">
                        <button class="btn btn-flat dropdown-toggle btn-sm" data-toggle="dropdown"
                                type="button"><i class="icon icon-locale"></i>
                            <span class="caret"></span></button>

                        <ul class="dropdown-menu">
                            <li v-for="lang in existing_languages"><a @click="change($event,lang)"
                                                                      class="action action-download"
                                                                      target="_blank"
                            ><i :class="['icon-flag-'+lang]"
                                class="icon icon-flag"></i><span>{{lang|uppercase}}</span></a>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {Youtube, getIdFromUrl} from 'vue-youtube';

    const getYoutubeId = (url) => {
        return getIdFromUrl(url)
    };

    export default {
        name: "VideoWatcher",
        props: ['watch'],
        components: {
            Youtube
        },
        data: function () {
            return {
                player: null,
                url: null,
                options: {
                    autoplay: false,
                    modestbranding: 1,
                    mute: false
                }
            }
        },
        computed: {
            videoId() {

                return !this.watch ? null : getYoutubeId(this.url);
            },
            existing_languages() {

                return !this.watch ? [] : Array.from(this.fields.existing_languages).sort();
            },
            fields() {
                if (!this.watch)
                    return {};

                let languageResult = this.watch.result.languages[this.watch.lang];
                let result = {fields: {}};
                const skip = ['existing_languages', 'level_0', 'level_1', 'level_2', 'level_3'];

                for (var key in languageResult.fields) {

                    if (languageResult.fields.hasOwnProperty(key)) {
                        let item = languageResult.fields[key];
                        if (item.length > 1 || skip.indexOf(key) !== -1) {
                            result.fields[key] = item;
                        } else {

                            if (isNaN(item[0])) {
                                result.fields[key] = item[0];
                            } else {
                                if (key === '_date_') {
                                    result.fields[key] = new Date(item[0] * 1000)
                                } else {
                                    result.fields[key] = parseInt(item[0]);
                                }

                            }
                        }
                    }
                }
                return result.fields;
            },
            previewThumbnail() {
                return "https://i.ytimg.com/vi/" + this.videoId + "/mqdefault.jpg";
            },
            fileCategories() {
                if (!this.watch)
                    return {};
                let filter = this.$options.filters.category;
                let cat = {};

                let cat_id = [].concat(this.fields.level_0, this.fields.level_1, this.fields.level_2, this.fields.level_3, this.fields.level_4).filter((i) => i);
                for (let i = 0; i < cat_id.length; i++) {
                    let name = filter(cat_id[i]);

                    if (!name)
                        continue;

                    if (!cat[name]) {
                        cat[name] = [];
                    }

                    cat[name].push(cat_id[i]);
                }
                return cat;
            }
        },
        methods: {
            playVideo() {
                this.player.playVideo()
            },
            playing() {},
            change($e, lang) {
                this.watch.lang = lang;
                this.updatePlayer();
                this.$emit('changeVideo', {id: this.watch.result.id, fields: this.fields});
            },
            updatePlayer() {
                let self = this;
                this.url = this.fields.url;
            }
        },
        watch: {
            watch() {
                this.updatePlayer();
            }
        },
        created() {

        }
    }
</script>

<style lang="less" scoped>
    .video-watcher {
        background-color: #fff;

        border-bottom: 1px solid #cccccc;

        .video-info {
            padding: 25px 40px;

            .date {
                font-size: 13px;
            }

            .title {
                font-size: 15px;
                font-family: "Fedra Sans Alt Demi", Helvetica, Arial, sans-serif;
            }

            .action-preview,
            .file-preview-info {
                display: inline-block;
            }

            .file-preview-info {
                padding-right: 10px;
            }

            .actions {
                padding: 10px 0;
            }
        }

    }


</style>
